export const fr = {
  search: {
    placeholder: "Entrez un mot à rechercher...",
    results: "Afficher les résultats de la recherche",
    search: "Recherche",
  },
};
